import { useSelector } from 'react-redux';

import { useDeskId } from '@/hooks/useDeskId';
import { useIntegrations } from '@/hooks/useIntegrations';
import { getPermissions } from '@/redux/permissions/selectors';
import { selectIntegrationId } from '@/redux/session/selectors';
import { MstatViberIntegration } from '@/shared/types/integration';
import { actions } from '@/shared/types/permissions';
import { RootState } from '@/shared/types/state';

import CredentialsCard from './CredentialsCard';
import MstatSetupCard from './MstatSetupCard';
import IntegrationConfigWrapper from '../Components/Integration';
import { SessionTimeoutCard } from '../Components/SessionTimeoutCard';

// 7 days — matches the orchestrator's default `mstat-viber` session timeout.
const DEFAULT_SESSION_TIMEOUT = 604800;

/**
 * MSTAT Viber Business integration configuration.
 *
 * Viber delivered through the MSTAT / omni-messaging gateway. The setup card
 * holds the inbound endpoints + webhook token to register in MSTAT, and the
 * credentials card holds the MSTAT API credentials.
 */
const MstatViber = () => {
  const integrationId = useSelector(selectIntegrationId);
  const deskId = useDeskId();
  const canWrite = useSelector((state: RootState) =>
    getPermissions(state, 'integrations', actions.WRITE)
  );
  const { integration } = useIntegrations<MstatViberIntegration>(deskId, integrationId);

  if (!integration) {
    return null;
  }

  return (
    <IntegrationConfigWrapper integration={integration}>
      <MstatSetupCard integration={integration} />
      <CredentialsCard integration={integration} />
      <SessionTimeoutCard
        integration={integration}
        canWrite={canWrite}
        defaultSeconds={DEFAULT_SESSION_TIMEOUT}
      />
    </IntegrationConfigWrapper>
  );
};

export default MstatViber;
